import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera, FileText, CalendarDays, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Patrimoine et mémoire",
  title: "Musées de l'UNISIC",
  banner_image: "/media/museum-classical.jpg",
  intro:
    "Les Musées de l'UNISIC conservent et valorisent le patrimoine visuel, documentaire et événementiel de l'université.",
};

const SECTIONS = [
  {
    key: "photos",
    to: "/services/musees/archives-photos",
    Icon: Camera,
    color: "#0A2E52",
    eyebrow: "Galerie chronologique",
    title: "Archives photos",
    desc: "Photographies retraçant la vie universitaire, les cérémonies et les événements marquants.",
    image: "/media/museum-photos.jpg",
  },
  {
    key: "publications",
    to: "/services/musees/archives-publications",
    Icon: FileText,
    color: "#D4AF37",
    eyebrow: "Documents patrimoniaux",
    title: "Archives publications",
    desc: "Brochures, rapports d'activités et documents institutionnels historiques.",
    image: "/media/museum-publications.jpg",
  },
  {
    key: "evenements",
    to: "/services/musees/archives-evenements",
    Icon: CalendarDays,
    color: "#E63946",
    eyebrow: "Mémoire vive",
    title: "Archives Événements",
    desc: "Colloques, remises de diplômes, journées scientifiques et cérémonies officielles.",
    image: "/media/museum-events.jpg",
  },
];

export default function Musees() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content/service.musees").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
  }, []);

  return (
    <div data-testid="musees-hub">
      <section className="relative h-[46vh] min-h-[340px] w-full overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-14">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-4xl sm:text-5xl font-bold tracking-tight max-w-4xl">{content.title}</h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="eyebrow eyebrow-dark">Présentation</div>
        <span className="divider-gold mt-3" />
        <p className="mt-6 text-lg text-slate-700 leading-relaxed max-w-4xl whitespace-pre-line">{content.intro}</p>

        <div className="mt-14 grid gap-8 md:grid-cols-3">
          {SECTIONS.map((s) => (
            <Link key={s.key} to={s.to} className="group paper-card card-hover overflow-hidden flex flex-col" data-testid={`musee-card-${s.key}`}>
              <div className="relative h-48 overflow-hidden">
                <img src={s.image} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="inline-flex items-center justify-center w-10 h-10 rounded-sm mb-2" style={{ background: s.color, color: "#fff" }}>
                    <s.Icon className="w-5 h-5" />
                  </div>
                  <div className="text-[11px] tracking-[0.28em] uppercase text-white/80 font-semibold">{s.eyebrow}</div>
                  <h3 className="text-white text-xl font-bold mt-1">{s.title}</h3>
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <p className="text-sm text-slate-600 leading-relaxed flex-1">{s.desc}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-unisic-blue font-semibold text-sm group-hover:text-unisic-gold transition-colors">
                  Explorer <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
